// extracted by mini-css-extract-plugin
export var arrow = "ThreeChoiceButton-module--arrow--257e6";
export var arrowNo = "ThreeChoiceButton-module--arrow_no--9f8be";
export var arrowYes = "ThreeChoiceButton-module--arrow_yes--e0bdc";
export var button = "ThreeChoiceButton-module--button--c5fdd";
export var flex = "ThreeChoiceButton-module--flex--c2a48";
export var flex1 = "ThreeChoiceButton-module--flex_1--dc68e";
export var flexCenter = "ThreeChoiceButton-module--flex_center--5626d";
export var flexCenterCol = "ThreeChoiceButton-module--flex_center_col--9e3c6";
export var flexCol = "ThreeChoiceButton-module--flex_col--c7ba5";
export var flexFixCenterCol = "ThreeChoiceButton-module--flex_fix_center_col--5bdb9";
export var flexFixedCenterCol = "ThreeChoiceButton-module--flex_fixed_center_col--5ba4e";
export var rotating = "ThreeChoiceButton-module--rotating--664f1";
export var selected = "ThreeChoiceButton-module--selected--b3ff8";
export var threeChoiceButtonContainer = "ThreeChoiceButton-module--threeChoiceButtonContainer--eb6be";